import React from 'react';

const ContactMap = () => (
  <div>
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3876.081973397408!2d100.46640031483003!3d13.71348489037221!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29869fb3bc369%3A0x48a2196bea4900c0!2zVGhlIEtleSBCVFMg4Lin4Li44LiS4Liy4LiB4Liy4Lio!5e0!3m2!1sth!2sth!4v1528956262114"
      width="100%"
      height="350"
      title="My Location"
      style={{border:'0',width:'100%'}}
    ></iframe>
  </div>
);
export default ContactMap;


// WEBPACK FOOTER //
// ./src/components/contact/ContactMap.js